import { render } from "./document-ui.vue?vue&type=template&id=01c5ce44"
import script from "./document-ui.vue?vue&type=script&lang=js"
export * from "./document-ui.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__